import React from 'react';

import './scss/loading-indicator.scss';

const LoadingIndicator = () => <div className="loading-indicator" />;

export { LoadingIndicator };
